type Option = { text: string; occupation: string; industry: string };

let _cache: Option[] | null = null;
let _loading: Promise<Option[]> | null = null;

export async function loadOccupationIndustryOptions(): Promise<Option[]> {
  if (_cache) return _cache;
  if (_loading) return _loading;

  _loading = (async () => {
    try {
      const mod = await import('./loadOccupationIndustryOptions.constants');
      const data = mod.occupationIndustryOptions as Option[];
      _cache = data;
      return _cache;
    } finally {
      _loading = null;
    }
  })();

  return _loading;
}
